module.exports = __webpack_public_path__ + "media/components/page-payment/cards-8387dc12d11c3af3002d0dde41760fd2.svg";